var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquipment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9275 30.6953L17.5586 30.6953",
    stroke: "#1552E8",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5408 10.3125H26.0408C31.9435 10.3125 32.5338 13.0729 32.9331 16.4409L34.4956 29.4617C34.999 33.7325 33.6796 37.222 27.6033 37.222H11.9957C5.902 37.222 4.58256 33.7325 5.10339 29.4617L6.6659 16.4409C7.04784 13.0729 7.6381 10.3125 13.5408 10.3125Z",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8457 12.9166V6.84025C12.8457 4.2361 14.5818 2.5 17.186 2.5H22.3943C24.9984 2.5 26.7345 4.2361 26.7345 6.84025V12.9166",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9276 29.5391L10.8623 29.5391",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9991 20.6028C24.9991 21.0195 24.947 21.4231 24.8429 21.8138C24.7257 22.3346 24.5174 22.8424 24.2439 23.2851C23.3455 24.7955 21.6918 25.8111 19.7908 25.8111C18.4497 25.8111 17.2387 25.3033 16.3273 24.47C15.9367 24.1314 15.5981 23.7278 15.3377 23.2851C14.8559 22.5039 14.5825 21.5794 14.5825 20.6028C14.5825 19.1966 15.1424 17.9076 16.0539 16.9701C17.0044 15.9935 18.3325 15.3945 19.7908 15.3945C21.3273 15.3945 22.7205 16.0586 23.658 17.1263C24.4913 18.0508 24.9991 19.2747 24.9991 20.6028Z",
    fill: "#A020FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7337 20.5781H17.8535",
    stroke: "white",
    strokeWidth: 1.14285,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7939 18.6758V22.569",
    stroke: "white",
    strokeWidth: 1.14285,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/Equipment.c87bd6718d534667bafa906cd3fe9af6.svg";
export { ForwardRef as ReactComponent };